import { useQuery } from '@tanstack/react-query';
import { fetchCircuit } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCircuit = (id: number) =>
  useQuery({
    queryFn: async () => {
      const data = await extractData(fetchCircuit({ path: { id } }));
      return data;
    },
    queryKey: ['circuit', id],
  });
